/** @format */

import { useConfigStore } from '@/providers/ConfigStoreProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { ReactElement } from 'react';
import { StyledPrefixedInput } from './styled';

export interface PrefixedInputProps {
  postfix?: boolean;
  icon?: ReactElement;
  children?: any;
  disabled?: boolean;
}

export function PrefixedInput(props: PrefixedInputProps) {
  const selectedCurrencyIcon = useConfigStore((s) => s.currency.iconName);

  return (
    <StyledPrefixedInput {...props}>
      <span className="iconWrapper">
        {/*  @ts-ignore*/}
        {props.icon ?? <FontAwesomeIcon icon={['fas', selectedCurrencyIcon]} />}
      </span>

      {props.children}
    </StyledPrefixedInput>
  );
}

export default PrefixedInput;
